import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { DepersonalizeFileDataLoader } from '../helpers/ai/depersonalizeFileData/DepersonalizeFileDataLoader';
import { DepersonalizeFileDataViewer } from '../helpers/ai/depersonalizeFileData/DepersonalizeFileDataViewer';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const DepersonalizeFileData = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.DEPERSONALIZE.lightIcon : AI_UTILITIES.DEPERSONALIZE.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.DEPERSONALIZE.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.DEPERSONALIZE.name}</h4>
            </div>
            <Switch>
                <Route exact path={AI_UTILITIES.DEPERSONALIZE.path} component={DepersonalizeFileDataLoader} />
                <Route path={`${AI_UTILITIES.DEPERSONALIZE.path}/:inputIdentifier`} component={DepersonalizeFileDataViewer} />
            </Switch>
        </div>
    );
};

DepersonalizeFileData.displayName = 'DepersonalizeFileData';